import React from 'react';
import { Date } from '../../components/formatters';
import { LookbookActionButton } from './LookbookActionButton';

export function LookbookItem({ lookbook }) {
  const fileName = lookbook.data?.lookbookName
    ? lookbook.data.lookbookName
    : `LOOKBOOK_S${String(lookbook.id).padStart(3, '0')}`;

  return (
    <div className="lookbook-item">
      <div className="col">
        <div className="name">
          {fileName}
        </div>
        <div className="client">
          Client: {lookbook?.assigned_to?.first_name} {lookbook?.assigned_to?.last_name}
        </div>
        <div>
          Date: <Date date={lookbook.created_at} />
        </div>
      </div>

      <div className="col buttons">
        <LookbookActionButton lookbook={lookbook} />
      </div>
    </div>
  );
}
